function pathItemContractModifierDecorator() {
  class pathItemContractExtension {
    constructor() {
      this.contractExtensions = {};
    }

    addExtension(extensionProperty, extensionFn) {
      this.contractExtensions[extensionProperty] = extensionFn;
    }

    runExtensions(serverData, context) {
      _.forOwn(this.contractExtensions, (extensionFn, extensionProperty) => {
        context[extensionProperty] = extensionFn(serverData);
      });
    }
  }

  return new pathItemContractExtension();
}

angular.module('data-ng-path-item').service('pathItemContractModifierDecorator', pathItemContractModifierDecorator);



// WEBPACK FOOTER //
// ./app/vendor/data-ng-path-item/src/service/path_item_contract_modifier_decorator.es.js